import { render, staticRenderFns } from "./myTask_home.vue?vue&type=template&id=0bc74bc8&scoped=true"
import script from "./myTask_home.vue?vue&type=script&lang=js"
export * from "./myTask_home.vue?vue&type=script&lang=js"
import style0 from "./myTask_home.vue?vue&type=style&index=0&id=0bc74bc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc74bc8",
  null
  
)

export default component.exports